import isNil from 'lodash/isNil';
import find from 'lodash/find';

import {
    loanFormatKeyToObject,
    URL_LOANFORMAT_EAUDIOBOOKS,
    URL_LOANFORMAT_EBOOKS,
    URL_LOANFORMAT_ALL,
    isLoanFormatKey,
    URL_LOANFORMAT_EPRESS
} from '../../store/loanFormat/actions';
import {
    URL_BUNDLES_ROUTE,
    URL_FOREIGN_LANGUAGE_ROUTE,
    URL_LANGUAGE_LEARNING_ROUTE,
    URL_LOTE_ROUTE
} from '../../shop/language/constants';
import { URL_GENRES_ROUTE, URL_NEWLYADDED_ROUTE } from '../../shop/language/lote/constants';
import { URL_ALLPRODUCTS_ROUTE, URL_FEATURED_ROUTE } from '../../shop/language/languagelearning/constants';
import {
    URL_COLLECTION,
    URL_COLLECTION_BY_GENRE,
    URL_COLLECTION_COMPLETE,
    URL_COLLECTION_NEWLY_ADDED
} from '../../yourborrowbox/collection/constants';
import { URL_MARKETING_ROUTE } from '../../yourborrowbox/marketing/constants';
import { URL_CAMPAIGN_PRODUCTS_ROUTE } from '../../shop/campaigns/constants';

const loanFormatUrlRegex = `(${URL_LOANFORMAT_EAUDIOBOOKS}|${URL_LOANFORMAT_EBOOKS}|${URL_LOANFORMAT_EPRESS}|${URL_LOANFORMAT_ALL})`;

const FOREIGN_LANGUAGE_URL_REGEX = new RegExp(
    // eslint-disable-next-line no-useless-escape
    `${URL_FOREIGN_LANGUAGE_ROUTE}\/(${URL_LOTE_ROUTE}|${URL_LANGUAGE_LEARNING_ROUTE}|${URL_BUNDLES_ROUTE})\/${loanFormatUrlRegex}`,
    'i'
);

const FOREIGN_LANGUAGE_SUB_URL_REGEX = new RegExp(
    // eslint-disable-next-line no-useless-escape
    `${URL_FOREIGN_LANGUAGE_ROUTE}\/(${URL_LOTE_ROUTE}|${URL_LANGUAGE_LEARNING_ROUTE})\/(${URL_FEATURED_ROUTE}|${URL_NEWLYADDED_ROUTE}|${URL_GENRES_ROUTE}|${URL_ALLPRODUCTS_ROUTE})\/(.*?)\/${loanFormatUrlRegex}`,
    'i'
);

// eslint-disable-next-line no-useless-escape
const CAMPAIGN_PRODUCTS_URL_REGEX = new RegExp(`${URL_CAMPAIGN_PRODUCTS_ROUTE}\/${loanFormatUrlRegex}`, 'i');

const MARKETING_URL_REGEX = new RegExp(
    // eslint-disable-next-line no-useless-escape
    `${URL_MARKETING_ROUTE}\/${URL_CAMPAIGN_PRODUCTS_ROUTE}\/${loanFormatUrlRegex}`,
    'i'
);

const COLLECTION_NAVIGATION_REGEX = new RegExp(
    // eslint-disable-next-line no-useless-escape
    `${URL_COLLECTION}\/(${URL_COLLECTION_COMPLETE}|${URL_COLLECTION_NEWLY_ADDED}|${URL_COLLECTION_BY_GENRE})\/${loanFormatUrlRegex}`,
    'i'
);

function getLoanFormatFromString(regex, pathname) {
    const urlParts = pathname.match(regex);

    let urlLoanFormat;
    if (!isNil(urlParts)) {
        urlLoanFormat = find(
            urlParts,
            n => {
                return isLoanFormatKey(n);
            },
            1
        );
    } else {
        urlLoanFormat = null;
    }

    return loanFormatKeyToObject(urlLoanFormat);
}

export function getLoanFormatFromForeignLanguageUrl(pathname) {
    return getLoanFormatFromString(FOREIGN_LANGUAGE_URL_REGEX, pathname);
}

export function getLoanFormatFromForeignLanguageSubUrl(pathname) {
    return getLoanFormatFromString(FOREIGN_LANGUAGE_SUB_URL_REGEX, pathname);
}

export function getLoanFormatFromCampaignProductsUrl(pathname) {
    return getLoanFormatFromString(CAMPAIGN_PRODUCTS_URL_REGEX, pathname);
}

export function getLoanFormatFromMarketingUrl(pathname) {
    return getLoanFormatFromString(MARKETING_URL_REGEX, pathname);
}

export function getLoanFormatFromCollectionUrl(pathname) {
    return getLoanFormatFromString(COLLECTION_NAVIGATION_REGEX, pathname);
}
